import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import authReducer from './auth/authSlice';
import chatReducer from './chat/chatSlice';
import aiAgentReducer from './ai/aiAgentSlice';
import userReducer from './user/userSlice';
import adminReducer from './admin/adminSlice';
import organizationReducer from './organization/organizationSlice';
import sidebarReducer from './sidebar/sidebarSlice';
import aiUsageScoreReducer from './aiScore/aiUsageScoreSlice';
import documentReducer from './document/documentSlice';

// スライスリデューサーを追加
const rootReducer = combineReducers({
  auth: authReducer,
  chat: chatReducer,
  aiAgent: aiAgentReducer,
  user: userReducer,
  admin: adminReducer,
  organization: organizationReducer,
  sidebar: sidebarReducer,
  aiUsageScore: aiUsageScoreReducer,
  document: documentReducer
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false
    })
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
